import { createFileRoute } from '@tanstack/react-router';

import EditProductPage from '@/components/products/specific/edit/Page';

export const Route = createFileRoute('/products/$id/edit')({
	component: EditProductPage,
});
